<template>
  <v-card flat>
    <v-container id="loginContainer" fluid grid-list-md fill-height style="padding:0px; width:100%; height: 100vh;">
      <v-layout row fill-height>
        <v-flex d-flex md6 style="padding: 0;">
          <v-layout column style="height: 100vh;">
            <img width="280" :src="require('../assets/WiDE_Logo_Dark.png')" alt="" style="margin-left: 16px">
            <v-flex d-flex md12>
              <v-card fluid flat>
                <v-card-title>
                  <v-layout column>
                    <div style="padding:5px; font-size: 32px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(51,82,128);">
                      WiDE - WinGD Integrated Digital Expert
                    </div>
                    <div style="padding:10px; font-size: 18px !important; font-weight: 500; line-height: 1 !important;letter-spacing: 0.02em !important; color:rgb(115, 115, 115);">
                      Creating value from engine and ship data
                    </div>
                  </v-layout>
                </v-card-title>
                <v-card-text fluid style="padding-bottom: 0; height: 30rem; max-height: 30rem;">
                  <v-container fill-height grid-list-md style="padding-bottom: 0; height: 100%">
                    <v-layout column>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <v-text-field
                            ref="email_inp"
                            v-model="email"
                            label="Email"
                            v-on:keyup.enter="submitInput"
                        />
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <v-text-field
                            ref="pass_inp"
                            v-model="password"
                            :append-icon="((show) ? 'visibility' : 'visibility_off')"
                            :type="show ? 'text' : 'password'"
                            label="Password"
                            v-on:keyup.enter="submitInput"
                            @click:append="show = !show"
                        />
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 3)">
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="userLogin()">Login</v-btn>
                      </v-flex>
                      <v-flex md4 style="max-height: calc(100% / 12 * 2)">
                        <div style="height: 1rem;display: flex;flex-grow: 1;flex-direction: column;width: 100%;position: relative;justify-content: center;align-items: center;">
                          <hr style="width: 100%;">
                          <div id="loginInfoHolder">
                            or login with
                            <v-tooltip bottom color="white">
                              <template v-slot:activator="{ on, attrs }">
                                <font-awesome-icon
                                    icon="info"
                                    v-bind="attrs"
                                    v-on="on"
                                />
                              </template>
                              <span style="color: black"><pre style="font-family: inherit;" v-html="cognito_msg" /></span>
                            </v-tooltip>
                          </div>
                        </div>
                        <v-btn style="color:white; background-color: rgb(51,82,128); width: 100%; margin-left: 0;" flat @click="cognitoLogin()">Other Identity Provider</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-alert
                    id="loginAlertContainer"
                    class='alert'
                    :value="alert"
                    type="error"
                    transition="scale-transition"
                    color='rgb(205, 57, 64)'
                    outline dismissible
                    @input="closeAlert"
                >
                  <pre ref="alertTextDisplay" style="font-family: inherit;">{{ ((customAlert == '') ? 'The email and password you entered are not correct.' : customAlert) }}</pre>
                </v-alert>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex d-flex md6 style="padding: 0;">
          <img :src="require('../assets/EDS online login page.png')" alt="">
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>

import axios from 'axios'
import {globalStore} from "../main.js"
import {vessels} from "../main.js"

export default {
  name: "Login",
  components: {},
  data() {
    return {
      email: '',
      password: '',
      show: false,
      alert: false,
      customAlert: '',
      loggedIn: false,
      profile: {},
      cognito_msg: 'Please keep in mind, that to use a 3rd party Identity Provider,\nyour email address must be registered with WiDE Online.\nIf not please contact <a href="mailto:technical.request@wingd.com">technical.request@wingd.com</a>.'
    }
  },
  created() {

  },
  mounted() {
    var loginCokkie = window.$cookies.get('login');

    if (loginCokkie != null) {
      setTimeout(() => {
        window.$cookies.remove('login');
        this.customAlert = loginCokkie;
        this.alert = true;
      }, 500);
    }
  },
  methods: {
    closeAlert(v) {
      this.alert = false;
      this.customAlert = '';
    },
    submitInput() {
      if (this.email.length <= 0) {
        this.$refs["email_inp"].focus();
      } else if (this.password.length <= 0) {
        this.$refs["pass_inp"].focus();
      } else {
        this.userLogin();
      }
    },
    userLogin() {
      if (this.password.length <= 0) {
        this.alert = true;
      } else {
        let params = {withCredentials: true};

        axios.post(globalStore.config.api_location + '/login', {email: this.email.trim(), password: this.password.trim()}, params)
            .then(
                async (response) => {
                  if (response.status === 200) {
                    this.profile = response.data;

                    globalStore.auth_token = this.profile.jwt;

                    vessels.vessels = Object.assign([], this.profile.vessels);
                    await localStorage.setItem('vessels', JSON.stringify(this.profile.vessels));

                    globalStore.alertFilters = Object.assign({}, this.profile.rules);
                    await localStorage.setItem('alertFilters', JSON.stringify(globalStore.alertFilters));
                    window.$cookies.set('alertCheck', true);

                    globalStore.alerts = this.profile.notifications;
                    await localStorage.setItem('alerts', JSON.stringify(this.profile.notifications));

                    delete this.profile.vessels;
                    delete this.profile.rules;
                    delete this.profile.notifications;

                    globalStore.userProfile = this.profile;
                    globalStore.userLogged = true;

                    var base64Url = globalStore.userProfile.jwt.split('.')[1];
                    
                    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                    var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                    }).join(''));

                    window.$cookies.set('account_expiration', (JSON.parse(jsonPayload)).exp * 1000);
                    window.$cookies.set('user', globalStore.userProfile);

                    if (globalStore.requestedBeforeLogin.length) {
                      this.$router.push((new URL(globalStore.requestedBeforeLogin)).pathname.toString())
                    } else {
                      this.$router.push({path: 'dashboard'});
                    }
                  } else {
                    this.alert = true;
                  }
                },
                (error) => {
                  this.alert = true;
                }
            );
      }
    },
    cognitoLogin() {
      location = `${globalStore.config.api_location}/cognito`
    },
    loginWithCognitoCode() {
      let params = {withCredentials: false};

      axios.post(globalStore.config.api_location + '/cognito_login', {cognito_code: localStorage.cognito_code}, params)
          .then(
              async (response) => {
                localStorage.setItem('cognito_code', null);

                if (response.status === 200) {
                  this.profile = response.data;

                  globalStore.auth_token = this.profile.jwt;

                  vessels.vessels = Object.assign([], this.profile.vessels);
                  await localStorage.setItem('vessels', JSON.stringify(this.profile.vessels));

                  globalStore.alertFilters = Object.assign({}, this.profile.rules);
                  await localStorage.setItem('alertFilters', JSON.stringify(globalStore.alertFilters));
                  window.$cookies.set('alertCheck', true);

                  globalStore.alerts = this.profile.notifications;
                  await localStorage.setItem('alerts', JSON.stringify(this.profile.notifications));

                  delete this.profile.vessels;
                  delete this.profile.rules;
                  delete this.profile.notifications;

                  globalStore.userProfile = this.profile;
                  globalStore.userLogged = true;

                  var base64Url = globalStore.userProfile.jwt.split('.')[1];
                  var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                  var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
                    return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
                  }).join(''));

                  window.$cookies.set('account_expiration', (JSON.parse(jsonPayload)).exp * 1000);
                  window.$cookies.set('user', globalStore.userProfile);

                  if (globalStore.requestedBeforeLogin.length) {
                    this.$router.push((new URL(globalStore.requestedBeforeLogin)).pathname.toString())
                  } else {
                    this.$router.push({path: 'dashboard'});
                  }
                } else {
                  this.alert = true;
                }
              },
              (error) => {
                localStorage.setItem('cognito_code', null);

                if (error.response.data.error == 'Cognito user not found') {
                  this.$refs['alertTextDisplay'].innerHTML = this.cognito_msg;
                } else {
                  this.customAlert = error.response.data.error;
                }
                this.alert = true;
              }
          );
    },
    redirectToProvider() {
      let provider = localStorage.requested_provider;
      localStorage.setItem('requested_provider', null);
      location = `${globalStore.config.api_location}/identity_providers/redirect_to/${provider}`
    },
    handleLoginError() {
      let login_error = localStorage.login_error;
      localStorage.setItem('login_error', null);

      this.customAlert = login_error;
      this.alert = true;
    }
  },
  computed: {
    api_location: function () {
      return globalStore.config.api_location;
    }
  },
  watch: {
    api_location: function (location) {
      if (!!location && typeof location != 'undefined') {
        if (!window.$cookies.isKey('user') && !!localStorage.cognito_code && localStorage.cognito_code != 'null') {
          this.loginWithCognitoCode()
        } else if (!window.$cookies.isKey('user') && !!localStorage.requested_provider && localStorage.requested_provider != 'null') {
          this.redirectToProvider()
        } else if (!window.$cookies.isKey('user') && !!localStorage.login_error && localStorage.login_error != 'null') {
          this.handleLoginError()
        }
      }
    }
  }
}
</script>

<style>
  #loginAlertContainer {
    min-width: 35rem;
    text-align: center;
  }

  #loginInfoHolder {
    position:absolute;
    display: flex;
    background:white;
    padding: 0 8px;
    text-align: center;
    align-items: center;
  }

  #loginInfoHolder svg{
    border: 1px solid black;
    line-height: 8px;
    height: 8px;
    width: 8px;
    border-radius: 16px;
    padding: 3px;
    margin-left: 6px;
    font-size: 8px;
  }

</style>
<style scoped>

</style>
